var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-component": "base-time-picker" } },
    [
      _c(
        "div",
        { staticClass: "base-time-picker-inputs" },
        [
          _c("or-input", {
            attrs: {
              "data-input": "base-time-picker-hours",
              placeholder: "00",
              "model-value": _vm.hoursAsString,
              error: Boolean(_vm.error),
            },
            on: { input: _vm.onChangeHours },
          }),
          _vm._v(" "),
          _c("or-icon", { attrs: { icon: "go_to_line" } }),
          _vm._v(" "),
          _c("or-input", {
            attrs: {
              "data-input": "base-time-picker-minutes",
              placeholder: "00",
              error: Boolean(_vm.error),
              "model-value": _vm.minutesAsString,
            },
            on: { input: _vm.onChangeMinutes },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.error
        ? _c("or-error", [_vm._v("\n    " + _vm._s(_vm.error) + "\n  ")])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }